export enum MedicalCategory {
    InPatientFloors = 1,
    OutPatientClinic = 2,
    Emergency = 3,
    Laboratory = 4,
    Radiology = 5,
    OperatingTheatre = 6,
    Pharmacy = 7
}